import React from "react";
import ReactDOM from "react-dom";
import LandingPage from "./LandingPage";

ReactDOM.render(
  <LandingPage />,
  document.getElementById("root")
);